import { computed, Injectable, signal } from "@angular/core";
import { PrintingStateModel } from "../Dto/PrintingStateModel";
import { PrintingEntity } from "../Dto/PrintingModel";
import { PaginationInfo } from "../Dto/PrintingSearchResponse";
import { PrintingSearchRequest } from "../Dto/PrintingSearchRequest";

const initialState: PrintingStateModel = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, pages: 0 },
  searchParams: { page: 1, limit: 10 },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class PrintingState {
  private readonly state = signal<PrintingStateModel>(initialState);

  public readonly data = computed(() => this.state().data);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setPrintings(data: PrintingEntity[], pagination: PaginationInfo): void {
    this.state.update((state) => ({ ...state, data, pagination, loading: false, error: null }));
  }

  setSearchParams(params: PrintingSearchRequest): void {
    this.state.update((state) => ({ ...state, searchParams: params }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  addPrinting(entity: PrintingEntity): void {
    this.state.update((state) => ({
      ...state,
      data: [entity, ...state.data],
      pagination: { ...state.pagination, total: state.pagination.total + 1 },
    }));
  }

  updatePrinting(entity: PrintingEntity): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.map((item) =>
        (() => {
          if (item.id === entity.id) {
            return entity;
          }
          return item;
        })(),
      ),
    }));
  }

  removePrinting(id: string): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.filter((item) => item.id !== id),
      pagination: { ...state.pagination, total: Math.max(0, state.pagination.total - 1) },
    }));
  }
}
